import './LtLabel.scss';

const LtLabel = ({
  children,
  htmlFor,
  required,
  className = '',
  marginBottom = '8px',
  style = {},
}) => {
  const combinedStyle = {
    marginBottom: typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,
    ...style,
  };

  return (
    <label
      htmlFor={htmlFor}
      className={`lt-label ${className}`}
      style={combinedStyle}
    >
      {children}
      {required && <span className="asterisk">*</span>}
    </label>
  );
};

export default LtLabel;
